<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('subOrder:create')" @click="createOrder">新建订单
      </Button>
      <Button type="primary" icon="ios-download-outline" v-if="isHavePermission('subOrder:import')"
              style="margin-left: 10px" @click="importOrder">导入订单
      </Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px;">刷新</Button>

      <div class="search-filter">
        <Poptip placement="top-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="订单编号" field="ordersNumAttached" span="12">
                <template v-slot>
                  <vxe-input v-model="searchFormData.ordersNumAttached" placeholder="输入编号"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="关联主订单" field="relOrdersNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.relOrdersNum"
                      placeholder="输入关联主订单"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="所属公司" field="CompIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchComp"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'compOptions', 'twoOrders', 'queryAttachedOrderKeyword', 6)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'compOptions')"
                      placeholder="输入所属公司"
                  >
                    <Option v-for="option in compOptions" :value="option.id" :key="option.id"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单类型" field="ordersType" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.ordersType"
                      :options="orderType"
                      placeholder="选择订单类型"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="订单标题" field="ordersTitleAttached" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.ordersTitleAttached"
                      placeholder="输入订单标题"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="异常校验" field="errList" span="12">
                <template v-slot>
                  <vxe-select
                      clearable
                      v-model="searchFormData.errList"
                      :options="orderErrOption"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="销售方" field="sellerIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSellerName"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'sellerNameOptions', 'twoOrders', 'queryAttachedOrderKeyword', 2)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'sellerNameOptions')"
                      placeholder="输入销售方"
                  >
                    <Option v-for="option in sellerNameOptions" :value="option.id" :key="option.id"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="saleManIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesMan"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="
                      (file) =>
                        remoteMethod(file, 'salesManOptions', 'twoOrders', 'queryAttachedOrderKeyword', 3)
                    "
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
                      placeholder="输入业务员"
                  >
                    <Option v-for="option in salesManOptions" :value="option.id" :key="option.id"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUserIdList" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      filterable
                      clearable
                      :default-label="[]"
                      :loading="searchLoading"
                      :remote-method="(file) => remoteMethod(file, 'createUserOptions', 'twoOrders', 'queryAttachedOrderKeyword', 4)"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'createUserOptions')"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserOptions" :value="option.id" :key="option.id">
                      {{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="按创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select clearable v-model="searchFormData.createTime" :options="timeOptions"
                              placeholder="选择时间"></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置</Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <vxe-toolbar ref="xToolbar1" custom></vxe-toolbar>
    </div>

    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          stripe
          highlight-hover-row
          show-footer
          show-overflow
          ref="xGrid"
          max-height="560"
          border="none"
          align="center"
          :loading="loading"
          :data="orderListData"
          :footer-method="footerMethod"
          :filter-config="{ remote: true }"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="120"></vxe-table-column>
        <vxe-table-column width="30">
          <template slot-scope="{ row }">
            <Dropdown v-if="isHavePermission('subOrder:delete')" trigger="click" style="cursor: pointer" transfer>
              <icon
                  type="text"
                  custom="iconfont icon-gengduo"
                  size="16px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button
                      class="button-gengduo"
                      v-if="isHavePermission('subOrder:delete')"
                      @click="commitDelete(row.id)"
                      style="color: #ed4014"
                  >删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNumAttached" title="订单编号" min-width="130">
          <template slot-scope="{ row }">
            <a @click="openDetail(row.id)">{{ row.ordersNumAttached }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="relOrdersNum" title="关联主订单" min-width="120" align="center">
          <template slot-scope="{ row }">
            <a @click="openOrderDetail(row.relOrdersId)">{{ row.relOrdersNum }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" min-width="200"></vxe-table-column>
        <vxe-table-column field="ordersTypeText" title="订单类型" min-width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ordersTypeText }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersTitleAttached" title="订单标题" min-width="150"></vxe-table-column>
        <vxe-table-column field="sellerName" title="销售方" width="200"></vxe-table-column>

        <vxe-table-column field="payAmount" title="应付金额" min-width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payedAmount" title="已付金额" min-width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.payedAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="blanaceAmount" title="未付金额" min-width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.blanaceAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="invoiceAmount" title="发票金额" min-width="150" align="center" show-overflow>
          <template slot-scope="{ row }">
            <span>{{ row.invoiceAmount | formatMoney }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="saleMan" title="业务员" min-width="100"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" min-width="100"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <vxe-modal v-model="createModal" :title="title" width="1380" height="700" resize remember destroy-on-close>
      <create-order ref="createModal" @afterSave="closeCreateModal"></create-order>
    </vxe-modal>
    <vxe-modal v-model="templateOrderVisible" title="附属订单导入" width="1000" height="620" position="center"
               @close="closeOrderTemplate" remember>
      <import @goImport="goOrderImport" @close="closeOrderTemplate" ref="modalTemplate"></import>
    </vxe-modal>
    <vxe-modal v-model="importOrderModal" title="导入附属订单" width="1300" position="center" height="660" remember
               destroy-on-close>
      <import-order @afterSave="afterImport" ref="importModal"></import-order>
    </vxe-modal>
  </div>
</template>
<script>

import {formatMoney} from "@/filters/type";
import {isEmpty} from "@/utils/util";
import $api from "@/apiProvider";
import {SEARCH_TIME} from "@/filters/time";
import moment from "moment";
import CreateOrder from "@/views/subOrder/CreateOrder";
import getAuthOrization from "@/mixin/getAuthOrization";
import Import from "@/components/common/Import"; // 导入
import ImportOrder from "@/views/subOrder/ImportOrder";

export default {
  mixins: [getAuthOrization],
  components: {CreateOrder, Import, ImportOrder},
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
      searchFormData: {
        createTime: null,
      },
      open: false,
      orderListData: [],
      loading: false,
      orderErrOption: [
        {
          label: '应付账款未平衡',
          value: 1,
        }, {
          label: '进项发票与已付未平衡',
          value: 2,
        }
      ],
      ordersType: [],
      searchVisible: false,
      paramsObj: {
        page: 1,
        rows: 10,
        orderBy: 2,
      },
      searchLoading: false,
      timeOptions: SEARCH_TIME.options,
      searchComp: [],
      searchSellerName: [],
      sellerNameOptions: [],
      searchSalesMan: [], // 搜索业务员字段
      salesManOptions: [], // 搜索业务员下拉框
      searchCreateUser: [], // 搜索创建人字段
      createUserOptions: [], // 搜索创建人下拉框
      compOptions: [],
      title: '',
      createModal: false,
      orderType: [],
      templateOrderVisible: false,
      importOrderModal: false,
      orderFileUrl: null,
    }
  },
  watch: {
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
  },
  mounted() {
    this.getFileUrl();
    this.getDict(59000, 'orderType');
  },
  methods: {
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === "confirm") {
          this.deleteAttachedOrder(id);
        }
      });
    },
    async deleteAttachedOrder(id) {
      let res = await $api.twoOrders.request("deleteAttachedOrder", {
        id: id
      });
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.refresh();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    afterImport() {
      this.importOrderModal = false;
      this.refresh();
    },
    async getFileUrl() {
      let res = await $api.dict.post("queryDictByCode", {
        id: 305,
      });

      if (res.status === 1) {
        this.orderFileUrl = res.data.iconUrl;
      }
    },
    importOrder() {
      this.templateOrderVisible = true;
      this.$nextTick(() => this.$refs.modalTemplate.setExport("", "", this.orderFileUrl));
    },
    closeOrderTemplate() {
      this.templateOrderVisible = false;
    },
    goOrderImport() {
      this.templateOrderVisible = false;
      this.importOrderModal = true;
    },
    async getDict(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code,
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map((i) => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          });
        });
        this[key] = arr;
        this.getListData();
      } else {
        this.$XModal.message(res.message);
      }
    },
    openOrderDetail(id) {
      if (!this.isHavePermission("ordersTwo:detail")) {
        this.$Message["info"]({
          background: true,
          content: "对不起，您没有该权限！",
        });
        return;
      }
      let obj = {
        name: `订单详情2.0-${id}`,
        path: `/order2/orderdetail/${id}`,
      };
      window.open(obj.path);
      return false;
    },
    openDetail(id) {
      let obj = {};
      obj.name = `附属订单详情${id}`
      obj.path = `/subOrder/orderdetail/${id}`
      window.open(obj.path);
    },
    createOrder() {
      this.title = '创建附属订单';
      this.createModal = true;
    },
    closeCreateModal() {
      this.createModal = false;
      this.refresh();
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 2) {
            return "单页合计";
          }
          if (
              [
                "payAmount",
                "payedAmount",
                "blanaceAmount",
                "invoiceAmount",
              ].includes(column.property)
          ) {
            return formatMoney(this.$utils.sum(data, column.property));
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 2) {
            return "全部合计";
          }
          if (["payAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalPayAmount);
          }
          if (["payedAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalPayedAmount);
          }
          if (["blanaceAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalBlanaceAmount);
          }
          if (["invoiceAmount"].includes(column.property) && this.countRtnVo) {
            return formatMoney(this.countRtnVo.totalInvoiceAmount);
          }
          return null;
        }),
      ];
    },
    handlePageChange(e) {
      // 分页
      if (this.paramsObj) {
        this.paramsObj.page = e.currentPage;
        this.paramsObj.rows = e.pageSize;
        this.getListData(this.paramsObj);
      } else {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.getListData();
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        keyword: query,
      };
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          if (index < 10) {
            this[options].push(i);
          }
        });
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getListData(obj) {
      this.records = [];
      let params = obj ? obj : {
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
      };
      this.loading = true;
      let res = await $api.twoOrders.post("getAttachedOrderList", params);
      this.loading = false;
      if (res.status === 1) {
        let pageData = res.data;
        this.orderListData = pageData.rows;
        this.countRtnVo = pageData.countRtnVo;
        this.orderType.map(i => {
          this.orderListData.map(j => {
            if (j.ordersType === i.value) {
              j.ordersTypeText = i.label;
            }
          })
        })
        this.page.totalResult = pageData.total;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    handleChange(date) {
      this.timeVal = date;
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};

      Object.keys(obj).forEach((key) => {
        if (obj[key] !== null &&
            key !== "createTime" &&
            key !== "errList" &&
            obj[key] !== undefined
        ) {
          paramsObj[key] = obj[key];
        }

        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd = moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
        paramsObj.payedAmountStatus = null;
        paramsObj.invoicePayedStatus = null;
        if (obj.errList === 1) {
          paramsObj.payedAmountStatus = 0;
        } else if (obj.errList === 2) {
          paramsObj.invoicePayedStatus = 0;
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      if (this.searchSellerName.length > 0) {
        paramsObj.sellerIds = this.searchSellerName;
      }
      if (this.searchSalesMan.length > 0) {
        paramsObj.saleManIds = this.searchSalesMan;
      }
      if (this.searchCreateUser.length > 0) {
        paramsObj.createUserIds = this.searchCreateUser;
      }
      if (this.searchComp.length > 0) {
        paramsObj.platformCompanyIds = this.searchComp;
      }
      this.paramsObj = paramsObj;
      this.getListData(paramsObj);
      this.searchVisible = false;
    },
    refresh() {
      this.getListData(this.paramsObj);
    },
    reset() {
      this.searchSellerName = [];
      this.searchSalesMan = []; // 搜索业务员字段
      this.searchCreateUser = []; // 搜索创建人字段
      this.searchComp = [];

      this.searchFormData = {
        createTime: null,
      };
    },
  }
}
</script>
<style>
.search-filter .ivu-select-multiple .ivu-tag {
  max-width: 140px !important;
}
</style>